(function () {
  'use strict';

  // Idempotent: if this file is executed again, do not wrap document.createElement
  // (or add observers/listeners) a second time.
  if (window.__feitKlaviyoConsentGateInit) return;
  window.__feitKlaviyoConsentGateInit = true;

  /**
   * Blocks Klaviyo onsite behavioral tracking (Active on Site, Viewed Product, etc.)
   * until Shopify marketing consent is granted. Must run BEFORE content_for_header.
   */
  var BLOCKED_TYPE = 'text/klaviyo-blocked';
  var ALLOWED = false;
  var pendingScripts = [];
  var originalCreateElement = document.createElement.bind(document);

  window.__klaviyoMarketingAllowed = false;

  function isKlaviyoUrl(url) {
    if (!url || typeof url !== 'string') return false;
    var value = url.toLowerCase();
    return (
      value.indexOf('static.klaviyo.com') !== -1 ||
      value.indexOf('static-tracking.klaviyo.com') !== -1 ||
      value.indexOf('klaviyo.js') !== -1 ||
      (value.indexOf('klaviyo') !== -1 && value.indexOf('.js') !== -1)
    );
  }

  function isKlaviyoNode(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.tagName === 'SCRIPT') {
      return (
        isKlaviyoUrl(node.src) ||
        isKlaviyoUrl(node.getAttribute('src')) ||
        isKlaviyoUrl(node.getAttribute('data-src')) ||
        (node.textContent && /klaviyo|_learnq/i.test(node.textContent) && /static\.klaviyo|klaviyo\.js|_learnq/i.test(node.textContent))
      );
    }
    if (node.tagName === 'LINK') {
      return isKlaviyoUrl(node.href) || isKlaviyoUrl(node.getAttribute('href')) || isKlaviyoUrl(node.getAttribute('data-href'));
    }
    return false;
  }

  function clearKlaviyoCookies() {
    var cookies = document.cookie ? document.cookie.split(';') : [];
    var hostname = location.hostname;
    var root = hostname.replace(/^www\./, '');
    var domains = [hostname, '.' + root, '.' + hostname];

    cookies.forEach(function (part) {
      var name = part.split('=')[0].trim();
      if (!name) return;
      if (!/(^__kla|_kla|klaviyo)/i.test(name)) return;
      domains.forEach(function (domain) {
        document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 GMT; Domain=' + domain;
      });
      document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 GMT';
    });

    try {
      Object.keys(localStorage).forEach(function (key) {
        if (/klaviyo|kla/i.test(key)) localStorage.removeItem(key);
      });
    } catch (e) {}
  }

  function blockScriptNode(node) {
    if (!node || node.getAttribute('data-klaviyo-consent') === 'blocked') return;

    var src = node.getAttribute('src') || node.src || '';
    var dataSrc = node.getAttribute('data-src') || '';

    if (src) {
      node.setAttribute('data-klaviyo-src', src);
      node.removeAttribute('src');
      try {
        node.src = '';
      } catch (e) {}
    }
    if (dataSrc) {
      node.setAttribute('data-klaviyo-src', dataSrc);
      node.removeAttribute('data-src');
    }

    node.setAttribute('type', BLOCKED_TYPE);
    node.setAttribute('data-klaviyo-consent', 'blocked');
    pendingScripts.push(node);
  }

  function blockLinkNode(node) {
    var href = node.getAttribute('href') || node.href || '';
    var dataHref = node.getAttribute('data-href') || '';
    if (href) {
      node.setAttribute('data-klaviyo-href', href);
      node.removeAttribute('href');
    }
    if (dataHref) {
      node.setAttribute('data-klaviyo-href', dataHref);
      node.removeAttribute('data-href');
    }
    node.setAttribute('data-klaviyo-consent', 'blocked');
  }

  function releaseScript(node) {
    var src = node.getAttribute('data-klaviyo-src');
    if (!src) return;

    var script = originalCreateElement('script');
    Array.prototype.slice.call(node.attributes).forEach(function (attr) {
      if (attr.name === 'type' || attr.name === 'data-klaviyo-src' || attr.name === 'data-klaviyo-consent') return;
      script.setAttribute(attr.name, attr.value);
    });
    script.type = 'text/javascript';
    script.async = true;
    script.src = src;
    script.setAttribute('data-klaviyo-consent', 'allowed');
    (node.parentNode || document.head).insertBefore(script, node);
    if (node.parentNode) node.parentNode.removeChild(node);
  }

  function releaseLink(node) {
    var href = node.getAttribute('data-klaviyo-href');
    if (!href) return;
    node.href = href;
    node.removeAttribute('data-klaviyo-href');
    node.setAttribute('data-klaviyo-consent', 'allowed');
  }

  function allowKlaviyo() {
    if (ALLOWED) return;
    ALLOWED = true;
    window.__klaviyoMarketingAllowed = true;

    document.querySelectorAll('script[data-klaviyo-consent="blocked"]').forEach(releaseScript);
    document.querySelectorAll('link[data-klaviyo-consent="blocked"]').forEach(releaseLink);

    // Hydrate any performance-deferred Klaviyo assets
    document.querySelectorAll('script[data-src]').forEach(function (node) {
      var datasrc = node.getAttribute('data-src') || '';
      if (!isKlaviyoUrl(datasrc)) return;
      node.src = datasrc;
      node.removeAttribute('data-src');
    });
    document.querySelectorAll('link[data-href]').forEach(function (node) {
      var datahref = node.getAttribute('data-href') || '';
      if (!isKlaviyoUrl(datahref)) return;
      node.href = datahref;
      node.removeAttribute('data-href');
    });

    pendingScripts = [];
    document.dispatchEvent(new CustomEvent('klaviyoConsentGranted'));
  }

  function denyKlaviyo() {
    ALLOWED = false;
    window.__klaviyoMarketingAllowed = false;
    clearKlaviyoCookies();

    // Keep any newly injected Klaviyo nodes blocked
    document.querySelectorAll('script, link').forEach(function (node) {
      if (isKlaviyoNode(node) && node.getAttribute('data-klaviyo-consent') !== 'blocked') {
        if (node.tagName === 'SCRIPT') blockScriptNode(node);
        if (node.tagName === 'LINK') blockLinkNode(node);
      }
    });

    document.dispatchEvent(new CustomEvent('klaviyoConsentDenied'));
  }

  // Queue API calls until consent so early embed stubs don't track
  window._learnq = window._learnq || [];
  window.klaviyo = window.klaviyo || {
    push: function () {
      if (!ALLOWED) return;
      if (window._learnq && typeof window._learnq.push === 'function') {
        return window._learnq.push.apply(window._learnq, arguments);
      }
    },
    identify: function () {
      if (!ALLOWED) return;
    },
    track: function () {
      if (!ALLOWED) return;
    },
    openForm: function () {
      if (!ALLOWED) return;
    }
  };

  var observer = new MutationObserver(function (mutations) {
    if (ALLOWED) return;
    mutations.forEach(function (mutation) {
      Array.prototype.forEach.call(mutation.addedNodes || [], function (node) {
        if (node.nodeType !== 1) return;
        if (node.tagName === 'SCRIPT' && isKlaviyoNode(node)) {
          blockScriptNode(node);
        } else if (node.tagName === 'LINK' && isKlaviyoNode(node)) {
          blockLinkNode(node);
        } else if (node.querySelectorAll) {
          node.querySelectorAll('script, link').forEach(function (child) {
            if (!isKlaviyoNode(child)) return;
            if (child.tagName === 'SCRIPT') blockScriptNode(child);
            if (child.tagName === 'LINK') blockLinkNode(child);
          });
        }
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });

  // Patch createElement so dynamically injected Klaviyo scripts stay blocked
  document.createElement = function (tag) {
    var node = originalCreateElement(tag);
    if (String(tag).toLowerCase() !== 'script') return node;

    var descriptor = Object.getOwnPropertyDescriptor(HTMLScriptElement.prototype, 'src');
    if (!descriptor || !descriptor.set) return node;

    Object.defineProperty(node, 'src', {
      configurable: true,
      enumerable: true,
      get: function () {
        return descriptor.get.call(this);
      },
      set: function (value) {
        if (!ALLOWED && isKlaviyoUrl(value)) {
          this.setAttribute('data-klaviyo-src', value);
          this.setAttribute('type', BLOCKED_TYPE);
          this.setAttribute('data-klaviyo-consent', 'blocked');
          pendingScripts.push(this);
          return;
        }
        return descriptor.set.call(this, value);
      }
    });

    return node;
  };

  function marketingAllowedFromDetail(detail) {
    detail = detail || {};
    function allowed(keys) {
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        if (!Object.prototype.hasOwnProperty.call(detail, key)) continue;
        var value = detail[key];
        if (value === true || value === 'yes' || value === 'granted' || value === 'allow') return true;
        if (value === false || value === 'no' || value === 'denied' || value === 'deny') return false;
      }
      return false;
    }
    return allowed([
      'marketingAllowed',
      'firstPartyMarketingAllowed',
      'thirdPartyMarketingAllowed',
      'marketing'
    ]);
  }

  function applyConsentDetail(detail) {
    if (marketingAllowedFromDetail(detail)) {
      allowKlaviyo();
    } else {
      denyKlaviyo();
    }
  }

  function readStoredConsent(api) {
    if (!api || typeof api.currentVisitorConsent !== 'function') return null;
    var current = api.currentVisitorConsent() || {};
    var hasDecision = !!(current.analytics || current.marketing || current.preferences || current.sale_of_data);
    if (!hasDecision) return null;
    return current;
  }

  function onVisitorConsent(event) {
    applyConsentDetail((event && event.detail) || {});
  }

  document.addEventListener('visitorConsentCollected', onVisitorConsent);
  window.addEventListener('visitorConsentCollected', onVisitorConsent);

  function loadCustomerPrivacy() {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      var stored = readStoredConsent(window.Shopify.customerPrivacy);
      if (stored) applyConsentDetail(stored);
      return;
    }

    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;

    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        if (error) return;
        var stored = readStoredConsent(window.Shopify.customerPrivacy);
        if (stored) applyConsentDetail(stored);
      }
    );
  }

  // Default: blocked until consent
  denyKlaviyo();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadCustomerPrivacy);
  } else {
    loadCustomerPrivacy();
  }

  // Expose for performance optimizer / debugging
  window.__feitKlaviyoConsent = {
    allow: allowKlaviyo,
    deny: denyKlaviyo,
    isAllowed: function () {
      return ALLOWED;
    }
  };
})();
